export default "__VITE_ASSET__CIJwF_03__"